// extracted by mini-css-extract-plugin
export default {"container":"PromptButton_container__4IwqG","input":"PromptButton_input__IF20P","counter":"PromptButton_counter__8xjKS","deleteButton":"PromptButton_deleteButton__K3359"};